export default __webpack_public_path__ + "static/media/093-left-arrow-4.0596805b.png";